import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token from localStorage automatically
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("pf_admin_token") : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const submitEstimate = async (data, files = [], insuranceFiles = []) => {
  const fd = new FormData();
  fd.append("payload", JSON.stringify(data));
  for (const f of files) fd.append("files", f);
  // Insurance documents: parallel arrays for the file blobs and their categories.
  const categories = [];
  for (const item of insuranceFiles) {
    if (!item?.file) continue;
    fd.append("insurance_files", item.file);
    categories.push(item.category || "other");
  }
  if (categories.length) fd.append("insurance_categories", JSON.stringify(categories));
  const { data: res } = await axios.post(`${API}/estimates`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res;
};

export const subscribeNewsletter = async (email, honeypot = "") => {
  const { data } = await axios.post(`${API}/newsletter`, { email, honeypot });
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  localStorage.setItem("pf_admin_token", data.access_token);
  return data;
};

export const logout = () => localStorage.removeItem("pf_admin_token");
export const isLoggedIn = () => !!localStorage.getItem("pf_admin_token");
